<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title class="previewTitle">&nbsp;</h1>
<div mat-dialog-content>
  <app-builder-page [isPreview]="true" [id]="id"></app-builder-page>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button
    mat-button
    mat-dialog-close
    [routerLink]="['/' + canvasType + 's/edit', id]"
    class="button_small"
    *ngIf="editable"
  >
    Access {{ canvasType }}
  </button>
  <button
    mat-button
    mat-dialog-close
    [routerLink]="['/' + canvasType + 's/view', id]"
    class="button_small"
    *ngIf="!editable"
  >
    Access {{ canvasType }}
  </button>
</div>
